var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EmployeeHeader',{attrs:{"title":"Nuevo Empleado"}}),_c('hr'),_c('EmployeeForm',{attrs:{"employee":_vm.employee},on:{"onCreate":_vm.onCreate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }